import { Component, OnInit } from '@angular/core';
import { interval, Observable } from 'rxjs';

@Component({
  selector: 'app-bottommenu',
  templateUrl: './bottommenu.component.html',
  styleUrls: ['./bottommenu.component.scss']
})
export class BottommenuComponent implements OnInit {
  UserCondition
  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';
  constructor(
  ) {
   }
  cartLength
  length
  counts
  lengths
  sub
  ngOnInit(): void {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    this.cartLength = sessionStorage.getItem('orders-data')? sessionStorage.getItem('orders-data'):[]; 
 
    if(this.cartLength) {
      this.sub = interval(500)
      .subscribe((val) => {  this.cartLength = sessionStorage.getItem('orders-data');
      this.length = JSON.parse(this.cartLength)
      if(this.length !=0) {
        this.counts=   this.length?.map((item:any)=> {
          return item.indexVal
        })
         this.lengths = this.counts?.length
      }else {
        this.lengths = 0
      }
     });
    }
    else {
      this.counts = 0;
    }
  }



}
